import { render, staticRenderFns } from "./ComandaUnificarModal.vue?vue&type=template&id=0b4dc7cc"
import script from "./ComandaUnificarModal.vue?vue&type=script&lang=js"
export * from "./ComandaUnificarModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports